import { guardString } from "@msuite/utils/strings";
import { useEffect, useEffectEvent, useRef } from "react";

/** Props Interface */
interface UseWebSocketOptions {
	route: string;
	onMessage: (payload: unknown) => void;
}

const baseURL = guardString(process.env.PUBLIC_SERVER_URL)
	.replaceAll("https://", "wss://")
	.replaceAll("http://", "ws://");

export function useWebSocket({ route, onMessage }: UseWebSocketOptions) {
	const savedHandler = useRef(onMessage);

	useEffect(() => {
		savedHandler.current = onMessage;
	}, [onMessage]);

	const getRoute = useEffectEvent(() => {
		const _route = route.startsWith("/") ? route.slice(1) : route;
		return [baseURL, _route].join("/");
	});

	useEffect(() => {
		if (!route) return;

		const socket = new WebSocket(getRoute());

		socket.onopen = () => {};

		socket.onmessage = (event) => {
			savedHandler.current(event.data);
		};

		socket.onerror = (error) => {
			console.error("WebSocket Error:", error);
		};

		socket.onclose = () => {};

		return () => {
			socket.close();
		};
	}, [route]);
}
